module.exports = __webpack_public_path__ + "img/96ne.30d6f763.svg";